import { API_URL } from './api';

/**
 * Funnel intent telemetry from the dashboard.
 *
 * Records that a user left through a door Miles gave them (downloading the
 * plugin, copying the coding-agent instruction) so the funnel can tell that
 * apart from a signup that simply did nothing.
 *
 * Strictly fire-and-forget: nothing here may delay or cancel the click that
 * triggered it, and every failure stays in the console.
 */
export type IntentEventType =
  | 'plugin.download_clicked'
  | 'agent_instructions.copied';

export function reportIntentEvent(
  eventType: IntentEventType,
  surface: string,
  options: { url?: string; siteId?: string } = {},
): void {
  const body = JSON.stringify({
    eventType,
    surface,
    url: options.url ?? window.location.href,
    siteId: options.siteId,
  });

  // keepalive lets the request outlive a navigation started by the same click.
  // Session cookies still authenticate it, which sendBeacon cannot guarantee
  // across the dev proxy, so use fetch and never await it.
  void fetch(`${API_URL}/api/v2/cloud/intent-events`, {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body,
  }).catch((error) => {
    console.warn('[Miles] Failed to report intent event', eventType, error);
  });
}
